import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@playbooks/ui/components/card';
import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';

import type { SkeletonBaseProps } from './types';

const DisplaySkeleton = ({ className = '' }: SkeletonBaseProps) => {
	// Theme
	const rootClassName = cn('flex-column h-full gap-0 py-0', className);

	// Render
	return (
		<Card className={rootClassName}>
			<CardHeader className='aspect-[1/1] bg-surface-hover p-0 rounded-control m-4 w-14'>
				<Skeleton className='leading-[inherit]' />
			</CardHeader>
			<CardContent className='grow space-y-2 px-4 pb-4'>
				<CardTitle>
					<Skeleton className='w-1/2' />
				</CardTitle>
				<CardDescription>
					<Skeleton className='w-3/4' />
				</CardDescription>
				<CardDescription>
					<Skeleton className='w-3/4' />
				</CardDescription>
			</CardContent>
			<CardFooter className='flex-between gap-4'>
				<span className='w-24'>
					<Skeleton />
				</span>
				<span className='w-24'>
					<Skeleton />
				</span>
			</CardFooter>
		</Card>
	);
};
export { DisplaySkeleton };
